/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OrderSortBy {
  DATE = 'date',
  CREATED_AT = 'created_at',
}
